import * as XLSX from "xlsx";

const SHEET_NAME = "Outward";
const FILENAME = "outward_upload_format.xlsx";

const TEMPLATE_HEADERS = [
 "Company",
 "Product SKU",
 "Product Description", // ✅ NEW
 "Dispatch Quantity",
 "Vehicle Number",
 "Location",
 "Allocation Method",
 "Batch Number",
 "Batch Quantity",
];

const INSTRUCTIONS_ROW = [
 "Company name(s), comma separated for multiple (case-insensitive)",
 "Product SKU(s), comma separated for multiple products",
 "Product description(s), comma separated - keep same order as SKU list (optional)", // ✅ NEW
 "number > 0",
 "optional (grouping happens by Company+Vehicle)",
 "optional (e.g. Warehouse A)",
 "FEFO or MANUAL",
 "MANUAL only: Batch number(s), comma separated for multiple batches",
 "MANUAL only: Batch quantity(s), comma separated (sum must equal dispatch qty)",
];

const SAMPLE_ROW_FEFO = [
 "Company A",
 "SKU-001",
 "Desc for SKU-001", // ✅ NEW
 50,
 "VEH-001",
 "Warehouse A",
 "FEFO",
 "",
 "",
];

const SAMPLE_ROW_FEFO_2 = [
 "Company A, Company B",
 "SKU-002, SKU-003",
 "Desc SKU-002, Desc SKU-003", // ✅ NEW
 30,
 "VEH-001",
 "Warehouse A",
 "FEFO",
 "",
 "",
];

const SAMPLE_ROW_MANUAL = [
 "Company C",
 "SKU-003",
 "Desc for SKU-003", // ✅ NEW
 30,
 "VEH-002",
 "Warehouse B",
 "MANUAL",
 "BATCH-2025-001",
 30,
];

const SAMPLE_ROW_MANUAL_MULTIPLE = [
 "Company D",
 "SKU-004",
 "Desc for SKU-004", // ✅ NEW
 100,
 "VEH-003",
 "Warehouse B",
 "MANUAL",
 "BATCH-2025-001, BATCH-2025-002",
 "50, 50",
];

export function downloadOutwardUploadTemplate() {
  const wsData = [
    TEMPLATE_HEADERS,
    INSTRUCTIONS_ROW,
    SAMPLE_ROW_FEFO,
    SAMPLE_ROW_FEFO_2,
    SAMPLE_ROW_MANUAL,
    SAMPLE_ROW_MANUAL_MULTIPLE,
  ];

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  ws["!cols"] = [
   { wch: 30 }, // Company
   { wch: 35 }, // Product SKU
   { wch: 35 }, // ✅ Product Description (NEW)
   { wch: 18 }, // Dispatch Quantity
   { wch: 16 }, // Vehicle Number
   { wch: 18 }, // Location
   { wch: 20 }, // Allocation Method
   { wch: 35 }, // Batch Number
   { wch: 25 }, // Batch Quantity
 ];

  const startRow = 3;
  const endRow = 5000;

  ws["!dataValidation"] = [
    {
      type: "list",
      allowBlank: 0,
      sqref: `F${startRow}:F${endRow}`,
      formulas: ['"FEFO,MANUAL"'],
    },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, SHEET_NAME);

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = FILENAME;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
